// extracted by mini-css-extract-plugin
module.exports =  {"root":"h2vGuxirnTxtUQasFih6"};